import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import {withRouter, RouteComponentProps} from "react-router-dom"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"

import {connect} from "@irati/store"
import {ReduxState} from "@irati/store/types"
import id from "@irati/utils/id"
import Loading from "@irati/ui/src/Loading"
import History from "@irati/utils/history"
import session from "@irati/auth/services/session"
import authentication from "@irati/auth"

import FullLogin from "./DefaultLogin/FullLogin"

interface Props extends RouteComponentProps {
  isMobile: boolean
  formatMessage: FormatMessage
}

interface State {
  email: string
  load: Promise<any> | null
  submit: Promise<any> | null
}

interface Context {
  appPath: string
  apps: {[key: string]: string}
}

class DefaultLogin extends Component<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired,
    apps: PropTypes.object.isRequired
  }

  constructor(props: Props, context: Context) {
    super(props, context)

    this.state = {
      email: "",
      load: this.getSessionPostData(),
      submit: null
    }
  }

  getSessionPostData = () => {
    const load = session
      .getThenRemove(["email"])
      .then((data) => {
        if (data && data.email) {
          const {email} = data
          this.setState({email})
        }
      })
      .catch(() => {
        /* no-op, fail silently */
      })

    return load
  }

  redirectBackTo = () => {
    const {PUBLIC, ONBOARDING, WELCOME, HOME} = this.context.apps
    const nextPathname = get(this.props, "location.state.nextPathname", "")
    const isLogin = nextPathname.includes(WELCOME)
    if (!nextPathname || isLogin) {
      return null
    }
    if (nextPathname.includes(PUBLIC) || nextPathname.includes(ONBOARDING)) {
      return null
    }
    if (authentication.apps().admin && nextPathname.includes(HOME)) {
      return null
    }

    return nextPathname
  }

  handleContinue = () => {
    const {isMobile} = this.props
    const isAdmin = !!authentication.apps().admin
    const backTo = this.redirectBackTo()

    if (backTo) {
      return History.replace(backTo)
    }
    if (isAdmin && !isMobile) {
      return History.replace({pathname: "/"}, this.context.apps.ADMIN)
    } else {
      History.replace({pathname: "/"})
    }
  }

  render() {
    const {load, email} = this.state
    const idNamespace = id("default-login", this.props)

    return (
      <Loading load={load}>
        <FullLogin id={idNamespace} onContinue={this.handleContinue} postedEmail={email} />
      </Loading>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => {
  return {
    isMobile: mq.lessThan.medium
  }
}

export default withRouter(connect(mapStateToProps)(DefaultLogin))
